module.exports = __webpack_public_path__ + "static/media/elevated2-desktop.357ae3b6.webp";